import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Sessions from './pages/Sessions';
import FixedProxies from './pages/FixedProxies';
import Profiles from './pages/Profiles';
import AccountProfiles from './pages/AccountProfiles';
import PostCreator from './pages/PostCreator';
import CreatePost from './pages/CreatePost';
import ScheduledPosts from './pages/ScheduledPosts';
import PostLibrary from './pages/PostLibrary';
import Gallery from './pages/Gallery';
import Automation from './pages/Automation';
import Team from './pages/Team';
import InviteAccept from './pages/InviteAccept';
import Login from './pages/Login';
import Pending from './pages/Pending';
import AdminUsers from './pages/AdminUsers';
import ProtectedRoute from './components/ProtectedRoute';

// Garde par page : les membres d'équipe n'accèdent qu'aux pages autorisées.
const P = ({ page, children }) => <ProtectedRoute page={page}>{children}</ProtectedRoute>;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pending" element={<Pending />} />
          <Route path="/invite/:token" element={<InviteAccept />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<P page="dashboard"><Dashboard /></P>} />
            <Route path="sessions" element={<P page="accounts"><Sessions /></P>} />
            <Route path="proxies" element={<P page="proxies"><FixedProxies /></P>} />
            <Route path="profiles" element={<P page="profiles"><Profiles /></P>} />
            <Route path="account-profiles" element={<P page="groups"><AccountProfiles /></P>} />
            <Route path="library" element={<P page="library"><PostLibrary /></P>} />
            <Route path="gallery" element={<P page="gallery"><Gallery /></P>} />
            <Route path="post-creator" element={<P page="create"><CreatePost /></P>} />
            <Route path="scheduled" element={<P page="scheduled"><ScheduledPosts /></P>} />
            <Route path="automation" element={<P page="automation"><Automation /></P>} />
            <Route path="team" element={<ProtectedRoute ownerOnly><Team /></ProtectedRoute>} />
            <Route path="admin" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
            <Route path="post-creator-legacy" element={<P page="create"><PostCreator /></P>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
